// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { CreateMapByObj } from '../CreateMapByObjectUtils';
export var OrderTif;
(function (OrderTif) {
    OrderTif[OrderTif["Day"] = 1] = "Day";
    OrderTif[OrderTif["GTC"] = 2] = "GTC";
    OrderTif[OrderTif["IOC"] = 3] = "IOC";
    OrderTif[OrderTif["GTD"] = 4] = "GTD";
    OrderTif[OrderTif["FOK"] = 5] = "FOK";
    OrderTif[OrderTif["OnOpen"] = 6] = "OnOpen";
    OrderTif[OrderTif["OnClose"] = 7] = "OnClose";
    OrderTif[OrderTif["GTS"] = 9] = "GTS";
})(OrderTif || (OrderTif = {}));
export function getOrderTifKey(tif) {
    switch (tif) {
        case OrderTif.Day:
            return 'property.Day';
        case OrderTif.GTC:
            return 'property.GTC';
        case OrderTif.IOC:
            return 'property.IOC';
        case OrderTif.GTD:
            return 'property.GTD';
        case OrderTif.FOK:
            return 'property.FOK';
        case OrderTif.OnOpen:
            return 'property.OnOpen';
        case OrderTif.OnClose:
            return 'property.OnClose';
        case OrderTif.GTS:
            return 'property.GTS';
    }
}
// для мапинга ключей локализации
export const OrderTifMap = CreateMapByObj(OrderTif);
export function sortTifs(tifs) {
    const sortedTifs = [];
    const sortedTifList = [
        OrderTif.Day,
        OrderTif.GTC,
        OrderTif.IOC,
        OrderTif.FOK,
        OrderTif.GTD,
        OrderTif.OnOpen,
        OrderTif.OnClose,
        OrderTif.GTS
    ];
    for (let i = 0; i < sortedTifList.length; i++) {
        const index = tifs.indexOf(sortedTifList[i]);
        if (index !== -1) {
            sortedTifs.push(sortedTifList[i]);
        }
    }
    return sortedTifs;
}
